import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ChartDataset, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-graf-skladisce-lani-letos-datum-line',
  templateUrl: './graf-skladisce-lani-letos-datum-line.component.html',
  styleUrls: ['./graf-skladisce-lani-letos-datum-line.component.css']
})
export class GrafSkladisceLaniLetosDatumLineComponent implements OnInit {

  @Input() tableByDates;
  @Input() dateList;
  public lineChartData: ChartDataset[] = [
  ];
  public lineChartColors: any[] = [
    { // green
      backgroundColor: 'rgb(152,251,152)',
      borderColor: 'green',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgb(152,251,152)',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // red
      backgroundColor: 'rgba(255,0,0,0.3)',
      borderColor: 'red',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(255,0,0,0.3)',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },

  ];
  public lineChartLabels: string[];
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'nearest', // 'nearest', 'point', 'index', 'dataset', 'x', 'y'
      intersect: true // or false depending on your needs
    },
    plugins: {
      //to ne prikaže številk na grafu
      datalabels: {
        display: false,
      },
      legend: {
        display: false
      },
      tooltip: {
        // 'mode' is moved under 'interaction' in Chart.js 3, if needed, and 'label' mode might be replaced by 'item' or 'nearest'     
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            let value = context.parsed.y; // 'parsed.y' for Chart.js 3
            if (value >= 1000) {
              return label + ': ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
              return label + ': ' + value.toString();
            }
          },
          labelColor: function(context) {
            let index = context.datasetIndex;
            let chart = context.chart;
            let dataset = chart.data.datasets[index];
            // Assuming you have a way to determine the color based on the dataset or index
            let backgroundColor = index == 0 ? 'rgb(152,251,152)' : 'rgba(255,0,0,0.3)';
            let borderColor = index == 0 ? 'green' : 'red';
            return { backgroundColor: backgroundColor, borderColor: borderColor };
          }
        }
      },
      
    },
    
    elements: {
      point: {
        radius: 4
      }
    },
    
    scales: {
      x: {
        // X-axis configuration here
      },
      y: {
        ticks: {
          callback: function (value) {
            value = value.toString();
            var parts = value.split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(".");
          }
        },
        // Include any other y-axis configurations here
      },
      'y-axis-1': {
        position: 'right',
        grid: {
          color: 'rgba(255,0,0,0.3)',
        },
        ticks: {
          color: 'red', // 'fontColor' is changed to 'color' in Chart.js version 3
        }
      }
    },
    annotation: {
    },
  };

  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [pluginAnnotations];

  @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;
  public listValCmp = [];
  public listVal = [];
  public reversedListDates = [];
  constructor() { }

  ngOnInit() {
    console.log(this.tableByDates);
    console.log(this.dateList);
    console.log(this.dateList);
    this.getDates();
    this.getLists();
    this.lineChartLabels = this.reversedListDates;
    console.log(this.lineChartLabels);
    this.lineChartData = [
      { data: this.listVal, label: 'Letos' },
      { data: this.listValCmp, label: 'Lani' }
    ];
  }

  getDates() {
    for (let i = this.dateList.length - 1; i >= 0; i--) {
      this.reversedListDates.push(this.dateList[i]);
    }
  }

  getLists() {
    for (let i = this.tableByDates.length - 1; i >= 0; i--) {
      this.listVal.push(this.tableByDates[i][0]);
      this.listValCmp.push(this.tableByDates[i][1]);
    }
    console.log(this.listVal);
    console.log(this.listValCmp);

  }

  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
  }
}
